import { NavLink } from 'react-router-dom';
import type { MarketIndex } from '@/types/bot';
import { Badge } from '@/components/shared/Badge';
import { LiveClock } from '@/components/shared/LiveClock';
import { StatusDot } from '@/components/shared/StatusDot';
import { MarketTicker } from '@/components/shared/MarketTicker';
import './TopBar.css';

interface TopBarProps {
  totalPnlAud: number;
  syncStatus: 'OK' | 'DEGRADED' | 'ERROR';
  indices: MarketIndex[];
  onHamburgerClick?: () => void;
}

function formatAudPnl(value: number): string {
  const sign = value >= 0 ? '+' : '';
  return `${sign}A$${Math.abs(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export default function TopBar({ totalPnlAud, syncStatus, indices, onHamburgerClick }: TopBarProps) {
  const pnlClass = totalPnlAud >= 0 ? 'topbar__pnl-value--positive' : 'topbar__pnl-value--negative';
  const dotStatus = syncStatus === 'OK' ? 'active' : syncStatus === 'DEGRADED' ? 'paused' : 'error';

  return (
    <header className="topbar">
      <div className="topbar__left">
        <button
          className="topbar__hamburger"
          onClick={onHamburgerClick}
          aria-label="Toggle sidebar"
        >
          &#9776;
        </button>
        <span className="topbar__brand">NAKAR HFT</span>
        <Badge variant="success">PROD</Badge>
        <nav className="topbar__nav">
          <NavLink to="/dashboard" className={({ isActive }) => `topbar__nav-link${isActive ? ' topbar__nav-link--active' : ''}`}>Dashboard</NavLink>
          <NavLink to="/terminal" className={({ isActive }) => `topbar__nav-link${isActive ? ' topbar__nav-link--active' : ''}`}>Terminal</NavLink>
          <NavLink to="/audit" className={({ isActive }) => `topbar__nav-link${isActive ? ' topbar__nav-link--active' : ''}`}>Audit</NavLink>
        </nav>
      </div>

      <div className="topbar__center">
        <div className="market-ticker-wrap">
          <MarketTicker indices={indices} />
        </div>
        <div className="topbar__pnl">
          <span className="topbar__pnl-label">ALL P&L</span>
          <span className={`topbar__pnl-value ${pnlClass}`}>{formatAudPnl(totalPnlAud)}</span>
        </div>
      </div>

      <div className="topbar__right">
        <LiveClock />
        <div className="topbar__sync">
          <StatusDot status={dotStatus} />
          <span>Sync: {syncStatus}</span>
        </div>
      </div>
    </header>
  );
}
